import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react';
import { themes, getStoredTheme, applyTheme } from 'config/themes';

const ThemeSwitcher = ({ compact = false }) => {
  const [currentTheme, setCurrentTheme] = useState(getStoredTheme());

  useEffect(() => {
    // Apply theme on mount
    applyTheme(currentTheme);
  }, []);

  const handleThemeChange = (e, { value }) => {
    setCurrentTheme(value);
    applyTheme(value);
  };

  const themeOptions = Object.values(themes).map(theme => ({
    key: theme.id,
    text: theme.name,
    value: theme.id,
    description: compact ? null : theme.description,
    content: (
      <div className="flex items-center gap-2">
        <div
          className="w-4 h-4 rounded-full border border-gray-300"
          style={{ backgroundColor: theme.colors.primary }}
        />
        <span>{theme.name}</span>
      </div>
    ),
  }));

  return (
    <div className="theme-switcher">
      <Dropdown
        selection
        compact={compact}
        options={themeOptions}
        value={currentTheme}
        onChange={handleThemeChange}
        className="theme-dropdown"
        style={{
          minWidth: compact ? '120px' : '180px',
          backgroundColor: 'rgba(255,255,255,0.1)',
          color: 'white',
          border: '1px solid rgba(255,255,255,0.3)',
        }}
      />
    </div>
  );
};

export default ThemeSwitcher;
